import { tokens, IconButton } from '@arvoreeducacao/bonsai-ds'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 117px;
  display: flex;
  background-color: ${tokens.colors.white};
  box-shadow: ${tokens.shadows.shadowTop6};
  z-index: 11;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    flex-direction: column;
    justify-content: center;
    height: 100%;
    background-color: #f8fcff;
    box-shadow: none;
    padding-top: 56px;
    padding-bottom: 0;
  }
`

export const CommandButton = styled(IconButton).attrs(props => ({
  iconName: props.iconName,
  iconColor: props.iconColor || tokens.colors.black5,
  iconSize: 20,
  ghost: true,
  large: true,
  disabled: props.disabled || false
}))`
  background-color: transparent;
  ${props => `
    visibility: ${props.hidden ? 'hidden' : 'visible'}
  `};
`

export const Slider = styled.input.attrs({ type: 'range' })`
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: 0;

  &:focus-visible {
    outline: 2px solid ${tokens.colors.dark6};
    outline-offset: 2px;
  }

  height: 4px;
  padding: 2px 0px;
  flex: 1;
  border-radius: 40px;
  background: ${({ value = 10 }) =>
    css`linear-gradient(to right, ${tokens.colors.primary} 0%, ${tokens.colors.primary} ${value}%, ${tokens.colors.black3} ${value}%, ${tokens.colors.black3} 100%);`};

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    background: ${tokens.colors.primary};
    border-radius: 50%;
  }

  ::-moz-range-thumb {
    -moz-appearance: none;
    width: 10px;
    height: 10px;
    background: ${tokens.colors.primary};
    border-radius: 50%;
  }

  &:hover {
    ::-webkit-slider-thumb {
      width: 12px;
      height: 12px;
      background: ${tokens.colors.primary2};
    }

    ::-moz-range-thumb {
      width: 12px;
      height: 12px;
      background: ${tokens.colors.primary2};
    }
  }
`
